module.exports = __webpack_public_path__ + "img/parking-spots3.03219d38.png";